<div class="surface-card border-round mb-4" [ngClass]="[shadow, padding]">
  <div *ngIf="title" class="flex align-items-center justify-content-between mb-3">
    <div class="flex align-items-center gap-2">
      <i *ngIf="icon" class="text-primary" [class]="icon"></i>
      <h2 class="text-xl font-semibold text-900 m-0">{{ title }}</h2>
    </div>
    <div class="flex align-items-center gap-2">
      <p-tag *ngIf="badgeValue" [value]="badgeValue" [severity]="badgeSeverity"></p-tag>
      <ng-content select="[cardActions]"></ng-content>
    </div>
  </div>

  <ng-content></ng-content>
</div>
